import {
    TrumpfNotificationSeverity,
    TrumpfNotificationStatus,
    TrumpfNotificationType,
} from "@trumpf/ux.ui/dist/types/components/notification-item/notification-item.d";

export interface NotificationCenterResponse {
    nextPage: string;
    notificationCounter: number;
    limit: number;
    items: NotificationItem[] | null;
}

export interface NotificationItem {
    source: string;
    sourceLink: string;
    headline: string;
    text: string;
    status: TrumpfNotificationStatus;
    createdAt: string;
    timeFormat: string;
    dateFormat: string;
    severity: TrumpfNotificationSeverity;
    closeButtonText: string;
    closedByName: string;
    closedByLabel: string;
    type: TrumpfNotificationType;
    link: string;
    linkText: string;
    notificationUpdateEndpoint: string;
    notificationUpdateErrorText: string;
}
